import {
  Alert,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import Modal from "../../../../../components/Modal/Modal";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  filterFormErrorObject,
  filterObjectByValues,
  isAnyKeyValueTrue,
  mapObjectValues,
  objectHasKeys,
  validatePresence,
} from "../../../../../helpers/validationHelpers";
import useFormFieldsBlurState from "../../../../../hooks/useFormFieldsBlurState";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import ImageUploadSection from "../../../../../components/ImageUploadSection/ImageUploadSection";
import { uploadAssetToCloudinary } from "../../../../../utils/cloudinary";
import { updateOrganizationProfile } from "../../../../../hooks/useOrganizations";
import GoogleMapsAutocomplete from "../../../../../components/GoogleMapsAutoComplete/GoogleMapsAutoComplete";
import ErrorHelperText from "../../../../../components/ErrorHelperText/ErrorHelperText";
import { addNewOrganizationFavouriteLocation } from "../../../../../hooks/useOrganizationFavouriteLocations";

const OrganizationFavouriteLocationCreateModal = ({
  organizationId,
  accessToken,
  open,
  setOpen,
}: {
  organizationId?: string;
  accessToken: string;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const queryClient = useQueryClient();

  const [favouriteLocationText, setFavouriteLocationText] = useState("");
  const [favouriteLocation, setFavouriteLocation] = useState<any>(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // const { blurredFormFields, setFormFieldToBlurred, setFormFieldToFocused } =
  //   useFormFieldsBlurState({
  //     favouriteLocation,
  //   });

  const formErrors = {
    favouriteLocation:
      !favouriteLocation &&
      "Please enter an address for your favourite location",
  };

  // const parsedFormErrors = filterFormErrorObject(formErrors);

  const submitButtonDisabled = [formErrors.favouriteLocation].some((value) =>
    isAnyKeyValueTrue(value)
  );

  const resetFormFields = () => {
    setFavouriteLocation(null);
    setErrorMessage("");
    setSuccessMessage("");
  };

  const {
    mutate: handleAddNewOrganizationFavouriteLocation,
    isLoading: isAddNewOrganizationFavouriteLocationLoading,
  } = useMutation({
    mutationFn: addNewOrganizationFavouriteLocation,
    onSuccess: async (data) => {
      await queryClient.cancelQueries({
        queryKey: ["organization-favourite-locations", organizationId],
      });

      await queryClient.cancelQueries({
        queryKey: ["organization-favourite-locations", organizationId],
      });

      await queryClient.invalidateQueries({
        queryKey: ["organization-favourite-locations", organizationId],
      });
      setOpen(false);

      setSuccessMessage(
        "New organization favourite location successfully added"
      );
      resetFormFields();
    },
    onError: async (error: any) => {
      console.log("error", error);
      setErrorMessage(error);
      // setSubmitError(error);
    },
  });

  const handleSubmit = () => {
    setErrorMessage("");
    console.log("favourite location", favouriteLocation);
    handleAddNewOrganizationFavouriteLocation({
      organizationId,
      accessToken,
      formFields: {
        displayName: favouriteLocation?.shortName,
        address: favouriteLocation?.name,
        latitude: favouriteLocation?.latitude,
        longitude: favouriteLocation?.longitude,
      },
    });
  };

  return (
    <Modal
      open={open}
      loading={isAddNewOrganizationFavouriteLocationLoading}
      onSubmit={handleSubmit}
      onCancel={() => {
        setOpen(false);
      }}
      handleClose={() => {
        if (!isAddNewOrganizationFavouriteLocationLoading) {
          setOpen(false);
        }
      }}
      submitButtonLabel="Submit"
      title="Organization Favourite Location"
      submitButtonDisabled={submitButtonDisabled}
    >
      <Grid container spacing={2}>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={Boolean(successMessage)}
          autoHideDuration={6000}
          onClose={() => {
            setSuccessMessage("");
          }}
        >
          <Alert
            onClose={() => {
              setSuccessMessage("");
            }}
            severity="success"
            sx={{ width: "100%" }}
          >
            {successMessage}
          </Alert>
        </Snackbar>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={Boolean(errorMessage)}
          autoHideDuration={6000}
          onClose={() => {
            setErrorMessage("");
          }}
        >
          <Alert
            onClose={() => {
              setErrorMessage("");
            }}
            severity="error"
            sx={{ width: "100%" }}
          >
            {errorMessage}
          </Alert>
        </Snackbar>
        <Grid container item spacing={2}>
          <Grid item xs={12}>
            <GoogleMapsAutocomplete
              error={Boolean(formErrors?.favouriteLocation)}
              inputValue={favouriteLocationText}
              setInputValue={setFavouriteLocationText}
              value={favouriteLocation}
              setValue={setFavouriteLocation}
              accessToken={accessToken}
              label={"Favourite location address"}
            />
            {formErrors?.favouriteLocation && (
              <ErrorHelperText errorText={formErrors?.favouriteLocation} />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default OrganizationFavouriteLocationCreateModal;
